module.exports = __webpack_public_path__ + "media/images/spinner-cf6f52693d489c2978433d75ef638b15.gif";